import React, { useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";

const mt15 = {
    marginTop: 5
}

const isBrowserMt = isBrowser ? mt15 : null;

const LanguageCard = ({language, languageNames, languageLevels}) => {
    return (
        <>
            <Card>
                <Card.Body className={'p-30'}>
                    <Row>
                        <Col xs={isBrowser ? 6 : 12}>
                            <Row>
                                <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Idioma </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    { languageNames.find(x => x.id == language.idiomaId)?.nombre }
                                </Col>
                                <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                    <strong> Habla </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                    { languageLevels.find(x => x.id === language.idiomaNivelId)?.nombre }
                                </Col>
                            </Row>
                        </Col>
                        <Col style={!isBrowser ? mt15 : null}  xs={isBrowser ? 6 : 12}>
                            <Row>
                                <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Lee </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    { languageLevels.find(x => x.id === language.idiomaNivel1Id)?.nombre }
                                </Col>
                                <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                    <strong> Escribe </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                    { languageLevels.find(x => x.id === language.idiomaNivel2Id)?.nombre }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br/>
        </>
    );
};

export default LanguageCard;